/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CheckoutConfirmationRouteImport } from './routes/checkout-confirmation'
import { Route as ModifySubscriptionRouteImport } from './routes/modify-subscription'
import { Route as MInvoiceAppQrCodeRouteImport } from './routes/m/invoice-app-qr-code'
import { Route as MMateRouteImport } from './routes/m/mate'
import { Route as MMateVerifyRouteImport } from './routes/m/mate-verify'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutConfirmationRoute = CheckoutConfirmationRouteImport.update({
  id: '/checkout-confirmation',
  path: '/checkout-confirmation',
  getParentRoute: () => rootRouteImport,
} as any)
const ModifySubscriptionRoute = ModifySubscriptionRouteImport.update({
  id: '/modify-subscription',
  path: '/modify-subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const MInvoiceAppQrCodeRoute = MInvoiceAppQrCodeRouteImport.update({
  id: '/m/invoice-app-qr-code',
  path: '/m/invoice-app-qr-code',
  getParentRoute: () => rootRouteImport,
} as any)
const MMateRoute = MMateRouteImport.update({
  id: '/m/mate',
  path: '/m/mate',
  getParentRoute: () => rootRouteImport,
} as any)
const MMateVerifyRoute = MMateVerifyRouteImport.update({
  id: '/m/mate-verify',
  path: '/m/mate-verify',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/checkout': typeof CheckoutRoute
  '/checkout-confirmation': typeof CheckoutConfirmationRoute
  '/modify-subscription': typeof ModifySubscriptionRoute
  '/m/invoice-app-qr-code': typeof MInvoiceAppQrCodeRoute
  '/m/mate': typeof MMateRoute
  '/m/mate-verify': typeof MMateVerifyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/checkout': typeof CheckoutRoute
  '/checkout-confirmation': typeof CheckoutConfirmationRoute
  '/modify-subscription': typeof ModifySubscriptionRoute
  '/m/invoice-app-qr-code': typeof MInvoiceAppQrCodeRoute
  '/m/mate': typeof MMateRoute
  '/m/mate-verify': typeof MMateVerifyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/checkout': typeof CheckoutRoute
  '/checkout-confirmation': typeof CheckoutConfirmationRoute
  '/modify-subscription': typeof ModifySubscriptionRoute
  '/m/invoice-app-qr-code': typeof MInvoiceAppQrCodeRoute
  '/m/mate': typeof MMateRoute
  '/m/mate-verify': typeof MMateVerifyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/checkout'
    | '/checkout-confirmation'
    | '/modify-subscription'
    | '/m/invoice-app-qr-code'
    | '/m/mate'
    | '/m/mate-verify'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/checkout'
    | '/checkout-confirmation'
    | '/modify-subscription'
    | '/m/invoice-app-qr-code'
    | '/m/mate'
    | '/m/mate-verify'
  id:
    | '__root__'
    | '/'
    | '/checkout'
    | '/checkout-confirmation'
    | '/modify-subscription'
    | '/m/invoice-app-qr-code'
    | '/m/mate'
    | '/m/mate-verify'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CheckoutRoute: typeof CheckoutRoute
  CheckoutConfirmationRoute: typeof CheckoutConfirmationRoute
  ModifySubscriptionRoute: typeof ModifySubscriptionRoute
  MInvoiceAppQrCodeRoute: typeof MInvoiceAppQrCodeRoute
  MMateRoute: typeof MMateRoute
  MMateVerifyRoute: typeof MMateVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout-confirmation': {
      id: '/checkout-confirmation'
      path: '/checkout-confirmation'
      fullPath: '/checkout-confirmation'
      preLoaderRoute: typeof CheckoutConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/modify-subscription': {
      id: '/modify-subscription'
      path: '/modify-subscription'
      fullPath: '/modify-subscription'
      preLoaderRoute: typeof ModifySubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/m/invoice-app-qr-code': {
      id: '/m/invoice-app-qr-code'
      path: '/m/invoice-app-qr-code'
      fullPath: '/m/invoice-app-qr-code'
      preLoaderRoute: typeof MInvoiceAppQrCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/m/mate': {
      id: '/m/mate'
      path: '/m/mate'
      fullPath: '/m/mate'
      preLoaderRoute: typeof MMateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/m/mate-verify': {
      id: '/m/mate-verify'
      path: '/m/mate-verify'
      fullPath: '/m/mate-verify'
      preLoaderRoute: typeof MMateVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CheckoutRoute: CheckoutRoute,
  CheckoutConfirmationRoute: CheckoutConfirmationRoute,
  ModifySubscriptionRoute: ModifySubscriptionRoute,
  MInvoiceAppQrCodeRoute: MInvoiceAppQrCodeRoute,
  MMateRoute: MMateRoute,
  MMateVerifyRoute: MMateVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
